import React, { useEffect, useMemo, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/es";
import "../../App.css";
import moment from "moment";
import es from "date-fns/locale/es";
import { useStore } from "../../store/appStore";
import { useNavigate } from "react-router-dom";
import Cargando from "../cargando/cargando";

const localizer = momentLocalizer(moment);
moment.locale("es", es);

function CustomEvent({ event }) {
  return (
    <div
      style={{
        whiteSpace: "pre-line",
        fontSize: "10px",
        lineHeight: "1.2",
        padding: "2px 4px",
      }}
    >
      <strong>{event.title}</strong>
      {"\n"}
      {event.horario}
      {"\n"}
      {event.espacio}
      {"\n"}
      {event.pax} comensales adultos
    </div>
  );
}

function Calendario() {
  const { loadEventos, eventosStore, tiposEventosStore, loadTiposEventos } = useStore();
  const [eventos, setEventos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const navigate = useNavigate();

  // Memoizar la transformación de eventos
  const eventosTransformados = useMemo(() => {
    if (!eventosStore || !tiposEventosStore) return [];

    const eventosRenombrados = [];

    eventosStore.forEach((evento) => {
      // Evento principal
      if (evento?.fecha?.seconds) {
        eventosRenombrados.push({
          title: evento.cliente?.nombre || "Sin nombre",
          start: moment.unix(evento.fecha.seconds).toDate(),
          end: moment.unix(evento.fecha.seconds).toDate(),
          desc: "des",
          location: "location",
          id: evento.id,
          horario: evento?.horario?.nombre || "",
          espacio: evento?.espacio?.nombre || "",
          pax: evento.comensales?.find(c => c.nombre === "Adulto")?.cantidad || 0,
          tipo: evento.tiposEvento,
        });
      }

      // Evento de menú si existe
      if (evento?.fechaMenu?.seconds) {
        eventosRenombrados.push({
          title: `${evento.cliente?.nombre || "Sin nombre"} - Prueba Menú`,
          start: moment.unix(evento.fechaMenu.seconds).toDate(),
          end: moment.unix(evento.fechaMenu.seconds).add(2, "hours").toDate(),
          desc: "des",
          location: "location",
          id: `${evento.id}-menu`,
          horario: evento?.horarioMenu?.nombre || "",
          espacio: evento?.espacio?.nombre || "",
          pax: evento.pruebaMenuComensales || 0,
          tipo: "pruebaMenu",
        });
      }
    });

    return eventosRenombrados;
  }, [eventosStore, tiposEventosStore]);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setCargando(true);
        await Promise.all([loadTiposEventos(), loadEventos()]);
      } catch (error) {
        console.error("Error cargando datos:", error);
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, [loadEventos, loadTiposEventos]);

  const eventStyleGetter = (event) => {
    let backgroundColor = "#d9bb72";
    let color = "#fff";

    if (event.tipo === "pruebaMenu") {
      backgroundColor = "#71797E"; // Color gris para pruebas de menú
      color = "#fff";
    } else if (event.tipo?.nombre && tiposEventosStore) {
      const tipoEncontrado = tiposEventosStore.find(
        (tipo) => tipo.nombre === event.tipo.nombre
      );
      
      if (tipoEncontrado) {
        backgroundColor = tipoEncontrado.fondo || backgroundColor;
        color = tipoEncontrado.letra || color;
      }
    }

    return {
      style: {
        backgroundColor,
        color,
        borderRadius: "4px",
        border: "none",
      },
    };
  };

  const handleSelectEvent = (event) => {
    // Remover el sufijo "-menu" si existe para obtener el ID original
    const eventId = event.id.replace("-menu", "");
    navigate(`../eventos/listado/${eventId}`);
  };

  if (cargando || !eventosStore || !tiposEventosStore) {
    return <Cargando />;
  }

  return (
    <div className="app-container">
      <div className="selector-container"></div>
      <div className="calendar-container">
        <Calendar
          localizer={localizer}
          events={eventosTransformados}
          components={{
            event: CustomEvent,
          }}
          eventPropGetter={eventStyleGetter}
          startAccessor="start"
          endAccessor="end"
          views={["month", "week", "day"]}
          messages={{
            next: "Siguiente",
            previous: "Anterior",
            today: "Hoy",
            month: "Mes",
            week: "Semana",
            day: "Día",
            event: "Evento",
            time: "Horario",
            date: "Fecha",
            noEventsInRange: "No hay eventos en el rango seleccionado",
          }}
          tooltipAccessor={(event) =>
            `Cliente: ${event.title}\nHorario: ${event.horario}\nEspacio: ${event.espacio}\nComensales Adultos: ${event.pax}`
          }
          onDoubleClickEvent={handleSelectEvent}
          popup
          style={{ height: "80vh" }}
        />
      </div>
    </div>
  );
}

export default Calendario;